export default __webpack_public_path__ + "static/media/ldo_NEG_FIX_EN.441cbec6.svg";